import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing, Tween } from '@tweenjs/tween.js';
import Point from '../../../Utility/Point';
import ElementComponent from '../../../Component/UI/Element';
import TransformComponent from '../../../Component/Transform';
import { delay } from '../../../Utility/Task/TaskQueue';

interface IScaleMetaData {
    startScale: Point;
    endScale?: Point;
    duration?: number;
    delay?: number;
    easing?: (k: number) => number;
}

export class Scale extends AnimationClip<IScaleMetaData> {
    public *execute(
        gameObject: GameObject,
        meta?: IScaleMetaData
    ): IterableIterator<number> {
        const defaultDuration: number = 500;
        const elementComponent: ElementComponent = gameObject.getComponent(
            ElementComponent
        );
        meta.endScale = meta.endScale ? meta.endScale.clone() : new Point(1, 1);
        let tween: Tween;
        // TODO: Combine if else now that element scale is a point
        if (elementComponent) {
            const start: Point = meta.startScale
                ? meta.startScale.clone()
                : elementComponent.scale.clone();

            elementComponent.scale.copy(start);
            tween = this.getTween(elementComponent.scale);
            tween.to(
                { x: meta.endScale.x, y: meta.endScale.y },
                meta.duration ? meta.duration : defaultDuration
            );
        } else {
            const transformComponent: TransformComponent = gameObject.getComponent(
                TransformComponent
            );
            const start: Point = meta.startScale
                ? meta.startScale
                : (transformComponent.scale as Point);

            transformComponent.scale.copy(start);
            tween = this.getTween(transformComponent.scale);
            tween.to(
                { x: meta.endScale.x, y: meta.endScale.y },
                meta.duration ? meta.duration : defaultDuration
            );
        }

        tween.easing(meta.easing ? meta.easing : Easing.Linear.None);

        if (meta.delay) {
            yield* delay(meta.delay);
        }

        yield* this.startTween(tween);
    }
}
